import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut } from 'services/_http';

const base_url = `${urls.agents}/v1/analyst`;
const agent_url = `${urls.agents}/v1/agent/analyst`;

export const fetchDashboard = async (options = {}) => {
  return await apiGet(`${base_url}/dashboard`, { ...options });
};

export const fetchTenants = async (options = {}) => {
  return await apiGet(`${base_url}/tenants`, { ...options });
};

export const fetchTenantReport = async (tenant_id, options = {}) => {
  return await apiGet(`${base_url}/tenants/${tenant_id}`, { ...options });
};

export const fetchAnomalies = async (options = {}) => {
  return await apiGet(`${base_url}/anomalies`, { ...options });
};

export const fetchReports = async (options = {}) => {
  return await apiGet(`${base_url}/reports`, { ...options });
};

export const fetchReport = async (report_id, options = {}) => {
  return await apiGet(`${base_url}/reports/${report_id}`, { ...options });
};

export const actionRecommendation = async (report_id, index, actioned, options = {}) => {
  return await apiPut(`${base_url}/reports/${report_id}/recommendations/${index}/action`, {
    ...options,
    data: { actioned }
  });
};

export const fetchMonthlyReports = async (options = {}) => {
  return await apiGet(`${base_url}/monthly-reports`, { ...options });
};

export const fetchMonthlyReport = async (year, month, options = {}) => {
  return await apiGet(`${base_url}/monthly-reports/${year}/${month}`, { ...options });
};

export const triggerRun = async (options = {}) => {
  return await apiPost(`${agent_url}/run`, { ...options });
};

export const triggerCheck = async (options = {}) => {
  return await apiPost(`${agent_url}/check`, { ...options });
};
